import React, { memo } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import GlobalFooter from './GlobalFooter';
import CustomFooter from './CustomFooter';

interface LayoutProps {
  children: React.ReactNode;
  footerHtml?: string | null;
  footerCss?: string | null;
}

const Layout = memo<LayoutProps>(({ children, footerHtml, footerCss }) => {
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="flex-grow-1 d-flex flex-column">
        <Header />
        <main className="flex-grow-1 p-3">
          {children}
        </main>
        {footerHtml ? (
          <CustomFooter html={footerHtml} css={footerCss} />
        ) : (
          <GlobalFooter />
        )}
      </div>
    </div>
  );
});

export default Layout;